module.exports = __webpack_public_path__ + "img/icon_jiajiele.3c208ac5.png";